import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { formatPrice, isPriceOnRequest } from '../../utils/propertyHelpers';
import { resolveMediaUrl } from '../../utils/mediaUrl';
import { useTranslation } from '../../utils/translations';
import { getListingStatusLabel, resolveListingStatus } from '../../constants/listingStatus';
import { ImagePlaceholder } from '../loading';
import './PropertyCard.css';

const PropertyCard = ({ property }) => {
  const { t } = useTranslation();
  const { id, title, location, price, currency, area, bedrooms, bathrooms, transactionType, images, parkingIncluded } = property;
  const listingStatusLabel = getListingStatusLabel(resolveListingStatus(property), t);
  const transactionTypeLabel = t(`transactionTypes.${transactionType}`) || transactionType;
  const badgeLabel = listingStatusLabel || transactionTypeLabel;
  const firstImage = images && images.length > 0 ? images[0] : null;
  const [imageFailed, setImageFailed] = useState(false);

  return (
    <article className="property-card">
      <div className="property-image-container">
        {firstImage && !imageFailed ? (
          <ImagePlaceholder
            src={resolveMediaUrl(firstImage)}
            alt={title}
            className="property-image-placeholder"
            imgClassName="property-image"
            loading="lazy"
            draggable="false"
            onError={() => setImageFailed(true)}
          />
        ) : (
          <div className="no-image-placeholder">
            <div className="placeholder-icon">🏠</div>
          </div>
        )}
        <div className="property-badges">
          {badgeLabel ? (
            <span className="badge badge-transaction">{badgeLabel}</span>
          ) : null}
        </div>
        {parkingIncluded ? (
          <div
            className="property-badge-corner"
            title={t('propertyCard.parkingIncluded')}
          >
            <span className="badge badge-diagonal">
              <span className="badge-diagonal-line">{t('propertyCard.parkingIncludedLine1')}</span>
              <span className="badge-diagonal-line">{t('propertyCard.parkingIncludedLine2')}</span>
            </span>
          </div>
        ) : null}
      </div>
      <div className="property-content">
        <h3 className="property-title">{title}</h3>
        <p className="property-location">📍 {location}</p>
        <div className="property-details">
          <span>{area} m²</span>
          {bedrooms != null && bedrooms !== '' && (
            <>
              <span>•</span>
              <span>
                {bedrooms} {bedrooms === 1
                  ? t('propertyCard.bedroom')
                  : t('propertyCard.bedrooms')}
              </span>
            </>
          )}
          {bathrooms > 0 && (
            <>
              <span>•</span>
              <span>
                {bathrooms} {bathrooms === 1
                  ? t('propertyCard.bath')
                  : t('propertyCard.baths')}
              </span>
            </>
          )}
        </div>
        <div className="property-price">
          {transactionType === 'rent' ? (
            <span className="price">
              {formatPrice(price, currency, t('propertyCard.priceOnRequest'))}
              {!isPriceOnRequest(currency) && (
                <span className="price-period">/{t('propertyCard.month')}</span>
              )}
            </span>
          ) : (
            <span className="price">{formatPrice(price, currency, t('propertyCard.priceOnRequest'))}</span>
          )}
        </div>
      </div>
      <Link
        to={`/property/${id}`}
        className="property-card-link"
        aria-label={`${title}, ${location}`}
      />
    </article>
  );
};

export default PropertyCard;
